// extracted by mini-css-extract-plugin
export default {"month":"styles_month__oSbNb","week":"styles_week__TfRIF","day":"styles_day__ayDE0"};